// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1zedr","box":"WorkspacesBox_box__1JZ_v","node":"WorkspacesBox_node__Glbuj"};